import { gql } from 'src/__generated__'

export default gql(`
  mutation forgotPasswordRequest($data: ForgotPasswordRequestInput!) {
    forgotPasswordRequest(data: $data)
  }
`)
